import React from "react";
import OnlyFunds from "../../Assets/Images/logo.svg";
import OnlyFundsLight from "../../Assets/Images/LightLogo.svg";
import { useTheme } from "hooks/ThemeContext";

function Loading() {
  const { theme } = useTheme();
  return (
    <div className="w-full h-full fixed top-0 left-0 flex items-center justify-center">
      <img
        src={theme === "light" ? OnlyFundsLight : OnlyFunds}
        alt="Loading"
        className="scale-[2]"
      />
    </div>
  );
}

export default Loading;
